import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FilterProvider } from "./contexts/FilterContext";
import TopBar from "./components/TopBar";
import Sidebar from "./components/Sidebar";
import FilterBar from "./components/FilterBar";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";

// Check if user is authenticated
const isAuthenticated = () => {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
  return !!token;
};

// Protected Route - redirects to login if not authenticated
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Public Route - redirects to dashboard if already authenticated
const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

const DashboardLayout = () => {
  const [activeTab, setActiveTab] = useState("Productivity");
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleMobileSidebar = () => setIsMobileSidebarOpen(!isMobileSidebarOpen);
  const closeMobileSidebar = () => setIsMobileSidebarOpen(false);

  return (
    <FilterProvider>
      <div className="flex h-screen bg-gray-50 overflow-hidden">
        <Sidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isMobileOpen={isMobileSidebarOpen}
          onMobileClose={closeMobileSidebar}
        />
        <div className="flex-1 flex flex-col min-h-0 overflow-hidden bg-gray-50">
          <TopBar activeTab={activeTab} onMenuClick={toggleMobileSidebar} />
          <FilterBar activeTab={activeTab} />
          <div className="flex-1 min-h-0 overflow-auto">
            <Dashboard activeTab={activeTab} setActiveTab={setActiveTab} />
          </div>
        </div>
      </div>
    </FilterProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to={isAuthenticated() ? "/dashboard" : "/login"} replace />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
